import moment from 'moment';
import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';
import { PriceBookForm } from '../../../constants/constant_form_names';

const selector = formValueSelector(PriceBookForm);

const getFormUseMargin = (state) => {
  return selector(state, 'use_margin');
};

const getFormAvailableTo = (state) => {
  return selector(state, 'available_to');
};

const getFormAvailableFrom = (state) => {
  return selector(state, 'available_from');
};

const getFormRetailPrice = (state) => {
  return selector(state, 'retail_price');
};

const getFormTaxRate = (state) => {
  return selector(state, 'tax_rate');
};

const getFormCurrency = (state) => {
  return selector(state, 'currency') || {};
};

const getFormPriceLevels = (state) => {
  return selector(state, 'price_levels') || [];
};

const getFormPriceLevelByIndex = (state, index) => {
  return selector(state, `price_levels[${index}]`) || {};
};

const getFormQuantityBreak = (state, quantityBreak) => {
  return selector(state, quantityBreak) || {};
};

export const getUseMargin = createSelector(
  [getFormUseMargin],
  (useMargin) => useMargin,
);

export const getAvailableTo = createSelector(
  [getFormAvailableTo],
  (availableTo) => availableTo,
);

export const getAvailableFrom = createSelector(
  [getFormAvailableFrom],
  (availableFrom) => availableFrom,
);

export const getCurrencyCode = createSelector(
  [getFormCurrency],
  (currency) => currency.code,
);

export const getCurrencySymbol = createSelector(
  [getFormCurrency],
  (currency) => currency.symbol,
);

export const getAvailableToMinDate = createSelector(
  [getFormAvailableFrom],
  (availableFrom) => {
    return availableFrom || moment().startOf('day').format();
  },
);

export const hasUnfilledPriceLevel = createSelector(
  [getFormPriceLevels],
  (priceLevels) => {
    return priceLevels.some((priceLevel) => {
      const { price_level_id, quantity_break } = priceLevel;
      return !price_level_id || !(quantity_break || []).length;
    });
  },
);

export const getPriceLevelsSize = createSelector(
  [getFormPriceLevels],
  (priceLevels) => priceLevels.length,
);

export const getDefaultPriceLevel = createSelector(
  [getFormPriceLevelByIndex],
  (priceLevel) => priceLevel.default,
);

// export const getQuantityBreakRate = createSelector(
//   [getFormQuantityBreak, getFormRetailPrice, getFormTaxRate],
//   (quantityBreak, retailPrice, taxRate) => {
//     const rate = retailPrice - (retailPrice * ((quantityBreak.discount_percent) / 100));
//     const newRate = rate + (rate * (taxRate || 0));
//     return newRate;
//   },
// );
export const getQuantityBreakQuantityPrice = createSelector(
  [getFormQuantityBreak, getFormTaxRate],
  (quantityBreak, taxRate) => {
    const { rate, quantity } = quantityBreak;
    const quantityPriceExTax = rate * quantity;
    return (
      Number(quantityPriceExTax) + Number(quantityPriceExTax * (taxRate || 0))
    );
  },
);

export const getTaxRate = createSelector(
  [getFormTaxRate],
  (taxRate) => taxRate || 0,
);

export const getRetailPrice = createSelector(
  [getFormRetailPrice],
  (retailPrice) => retailPrice,
);

export const getQuantityBreakRate = createSelector(
  [getFormQuantityBreak],
  ({ rate }) => rate,
);

export const getQuantityBreakRateIncTax = createSelector(
  [getFormQuantityBreak],
  ({ rate_inc_tax }) => rate_inc_tax,
);

export const getQuantityBreakQuantity = createSelector(
  [getFormQuantityBreak],
  ({ quantity }) => quantity,
);

export const getQuantityBreakDiscountPercent = createSelector(
  [getFormQuantityBreak],
  ({ discount_percent }) => (discount_percent || 0) / 100,
);

export const getPriceLevels = createSelector(
  [getFormPriceLevels], (priceLevels) => priceLevels
);